import { render, staticRenderFns } from "./ThankYouOrderOnlinePickUp.vue?vue&type=template&id=b8107e80&scoped=true"
import script from "./ThankYouOrderOnlinePickUp.vue?vue&type=script&lang=js"
export * from "./ThankYouOrderOnlinePickUp.vue?vue&type=script&lang=js"
import style0 from "./ThankYouOrderOnlinePickUp.vue?vue&type=style&index=0&id=b8107e80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8107e80",
  null
  
)

export default component.exports